import { object, string } from 'yup';


export const mutateEventSchema = object({
  object_meta: object({
    namespace: string()
      .required('namespace is required.'),
  }),
  source: string()
    .required('source address is required.'),
  source_provider: string()
    .required('source_provider is required.'),
  action: string()
    .required('action is required.'),
  status: object({
    phase: string()
  }).required('status is required.')
});
